import Icon from '../Icon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setLoginModalOpen } from '../../Actions/Login.action';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { translate } from '../../Services/translation';
import IconText from '../MobileFooterMenu/IconText';

const StyledLoginModalWrapper = styled.button`
  cursor: pointer;
  ${breakpoint('large')} {
    padding: 1.6rem 0.8rem;
  }
  &:hover {
    opacity: 0.8;
  }
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

const StyledLoginIcon = styled(Icon)`
  font-size: 2rem;
  cursor: pointer;
`;
const LoginModalTrigger = () => {
  const dispatch = useDispatch();
  return (
    <StyledLoginModalWrapper
      aria-label={translate('general.login')}
      title={translate('general.login')}
      onClick={() => dispatch(setLoginModalOpen(true))}
      className='flex flex-col items-center gap-1'
    >
      <StyledLoginIcon name="user" />
      <IconText translationKey="general.login-desktop" />
    </StyledLoginModalWrapper>
  );
};
export default LoginModalTrigger;
